import Creatable from 'react-select/creatable';
import styled from 'styled-components';
import { color } from 'styled-system';

import { Label } from '../FormStyles';
import defaultAttrs from '../../lib/utils/defaultAttrs';

const customStyles = {
  control: provided => ({
    ...provided,
    background: 'transparent',
    borderRadius: '8px',
    borderColor: '#DBDDE0',
    cursor: 'pointer',
    minHeight: '44px',
  }),
  valueContainer: provided => ({
    ...provided,
    padding: '10px 16px',
  }),
  input: provided => ({
    ...provided,
    margin: 0,
    padding: 0,
    '& input': {
      margin: '0 !important',
    },
  }),
  placeholder: provided => ({
    ...provided,
    color: '#CACCCF',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
  option: provided => ({
    ...provided,
    wordBreak: 'break-word',
    fontSize: '14px',
    fontWeight: 500,
    color: '#25282B',
  }),
  menuList: provided => ({
    ...provided,
    color: '#25282B',
    textAlign: 'left',
  }),
};

const CreatableSelect = ({
  id,
  name,
  onChange,
  placeholder,
  options,
  isSearchable,
  isClearable,
  isDisabled = false,
  isMulti = false,
  label,
  dataTooltip,
  error,
  value,
  menuPortalTarget,
  menuPosition,
}) => {
  const styles = menuPortalTarget
    ? {
        ...customStyles,
        menuPortal: provided => ({
          ...provided,
          zIndex: 9999,
          fontFamily: "'Montserrat', sans-serif",
        }),
      }
    : customStyles;

  return (
    <SelectWrapper>
      {label && (
        <LabelWrapper>
          <InputLabel htmlFor={id}>{label}</InputLabel>
          {dataTooltip && <CircleExclamationIcon data-tip={dataTooltip} />}
          {error && <ErrorMessage color="error.default">{error}</ErrorMessage>}
        </LabelWrapper>
      )}
      <CustomSelect
        inputId={id}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        options={options}
        isSearchable={isSearchable}
        isClearable={isClearable}
        isDisabled={isDisabled}
        isMulti={isMulti}
        value={value}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPosition}
        components={{
          IndicatorSeparator: () => null,
        }}
        styles={styles}
      />
    </SelectWrapper>
  );
};

export default CreatableSelect;

const SelectWrapper = styled.div`
  font-family: 'Montserrat', sans-serif;
`;

const InputLabel = styled(Label)`
  margin: 0;
  line-height: 22px;
`;

const CircleExclamationIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-regular fa-circle-info',
  }),
)`
  margin: 0 4px;
`;

const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 8px;
`;

const ErrorMessage = styled.span`
  ${color};
  margin-left: auto;
  font-size: 14px;
  font-weight: 400;
`;

const CustomSelect = styled(Creatable)`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
`;
